import { render, staticRenderFns } from "./ProofNextVersion.vue?vue&type=template&id=01d47a22&scoped=true"
import script from "./ProofNextVersion.vue?vue&type=script&lang=js"
export * from "./ProofNextVersion.vue?vue&type=script&lang=js"
import style0 from "./ProofNextVersion.vue?vue&type=style&index=0&id=01d47a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d47a22",
  null
  
)

export default component.exports